module.exports = __webpack_public_path__ + "img/google-pay.b4b89e2c.png";